import { Box, Fade, Grow, styled } from '@mui/material'
import React from 'react'

interface Props {
  children: React.ReactNode
  position?: 'top-left' | 'top-right' | 'top' | 'bottom-left' | 'bottom-right' | 'bottom'
  type?: 'grow' | 'fade' | 'collapse' | 'slide' | 'zoom'
}

const Transitions = (props: Props) => {
  const { children, position = 'top-left', type = 'grow', ...others } = props

  return (
    <Box>
      {type === 'grow' && (
        <Grow {...others}>
          <StyledBox>{children}</StyledBox>
        </Grow>
      )}
      {type === 'fade' && (
        <Fade
          {...others}
          timeout={{
            appear: 0,
            enter: 300,
            exit: 150,
          }}
        >
          <StyledBox>{children}</StyledBox>
        </Fade>
      )}
    </Box>
  )
}

export default Transitions

const StyledBox = styled(Box)({
  transformOrigin: '0 0 0',
})
